import type { CircleRadius } from '../useMapCircleRadius.types';

/**
 * Checks if the circle radius is valid by checking if the center and radius
 * are valid numbers and the radius is greater than 0.
 */
export function checkIfValidCenterRadius(circleRadius: CircleRadius) {
  const { centerLat, centerLng, radiusInMiles } = circleRadius;

  return (
    Number.isFinite(centerLat) &&
    Number.isFinite(centerLng) &&
    Number.isFinite(radiusInMiles) &&
    radiusInMiles > 0
  );
}
